module.exports = __webpack_public_path__ + "static/media/Elementaryschoolcarnivalsigns12signsquicklyhandletteredonsite2008.26c1d5e9.webp";